import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WordmarkProps {
    className?: string
}

/* The BLITZ wordmark. Letters follow the surrounding text color; the square accent is always coral. */
export const Wordmark: FC<WordmarkProps> = ({ className }): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex items-end font-heading font-black uppercase leading-none tracking-[-0.045em]',
                className
            )}
        >
            <span>Blitz</span>
            <span aria-hidden='true' className='mb-[0.08em] ml-[0.07em] block size-[0.2em] bg-coral' />
        </span>
    )
}
